import { createAction, createReducer } from "@reduxjs/toolkit";

export const DEFAULT_LOCALE = "en_US";

export const setLocale = createAction<string>("SET_LOCALE");
const initState = { locale: DEFAULT_LOCALE };

export const appReducer = createReducer(initState, (builder) => {
    builder.addCase(setLocale, (state, { payload }) => {
        state.locale = payload;
    });
});
